import { Core } from "@faire/design-tokens";
import { Add } from "@faire/web--source/slate/icons/foundation/Add";
import { Column } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import React from "react";
import styled, { css } from "styled-components";

interface IProps {
  disabled?: boolean;
  onClick?: (
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => void | Promise<void>;
  "data-test-id"?: string;
}

export const RoundedPlusButton: React.FC<IProps> = (props) => {
  const [loading, setLoading] = React.useState(false);

  const onClick = React.useCallback(
    async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      try {
        setLoading(true);
        await props.onClick?.(e);
      } finally {
        setLoading(false);
      }
    },
    [props, setLoading]
  );

  return (
    <Container
      forwardedAs="button"
      {...props}
      role="button"
      onClick={onClick}
      disabled={loading || props.disabled}
    >
      {loading ? (
        <LoadingSpinner size="small" color={Core.text.inverse} />
      ) : (
        <Add />
      )}
    </Container>
  );
};

const Container = styled(Column).attrs({ align: "center", justify: "center" })`
  ${({ theme }) => css`
    background-color: ${theme.surface.muted};
    color: ${theme.text.default};
    border: solid 1px ${theme.border.muted};
    width: 32px;
    height: 32px;
    border-radius: 32px;
    flex: 0 0 auto;

    &:hover {
      background-color: ${theme.surface.default};
      color: ${theme.text.inverse};
      border-color: ${theme.border.default};
    }

    &:disabled {
      background-color: ${theme.surface.disabled};
      border-color: ${theme.border.disabled};
      color: ${theme.text.disabled};
    }
  `}
`;
